export default __webpack_public_path__ + "static/media/the-great-minimum.9f5b0686.jpg";